import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../constants/common'
import { ConfirmationModal } from '../../Confirmation'
import { LoaderText } from '../../LoaderText'
import { useExportDirectLink } from '../Export.hooks'

import { DirectLinks } from './DirectLinks'

function ExportDirectLinkModal({
  actionButtonsProps,
  subjectId,
  titleKey = 'Common.AttentionModalTitleKey',
  onCheckTask,
  onStartExport,
  ...restProps
}) {
  const { t } = useTranslation()

  const [loading, setLoading] = useState(false)
  const [files, setFiles] = useState(EMPTY_LIST)

  const { handleStartExport } = useExportDirectLink({
    onCheckTask,
    onSetFilesIds: setFiles,
    onSetLoading: setLoading,
    onStartExport,
  })

  useEffect(() => {
    handleStartExport(subjectId)
  }, [])

  return (
    <ConfirmationModal
      {...restProps}
      Description={files.length > 0 ? DirectLinks : null}
      actionButtonsProps={{
        ...actionButtonsProps,
        Submit: null,
      }}
      descriptionProps={{ filesIds: files }}
      title={t(titleKey)}
    >
      {loading ? <LoaderText /> : null}
    </ConfirmationModal>
  )
}

export default ExportDirectLinkModal
